import {qs} from "./dom"

export default async (args) => {
  const {method, data, endpoint} = args

  let root = qs('#custom-admin-root')?.value || themeVars?.root
  let new_nonce = qs('#new_wp_nonce')?.value || qs('#custom-admin-nonce')?.value || themeVars?.nonce

  try {
    const reqBody = {
      method,
      credentials: 'same-origin',
      headers: {
        "X-WP-Nonce": new_nonce,
      },
      body: data,
    }

    const res = await fetch(`${root}api/${endpoint}`, reqBody)

    return res.json()

  } catch (err) {
    console.error('Request failed', err.message)
  }
}
